"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var RadixPopover = _interopRequireWildcard(require("@radix-ui/react-popover"));
var _react = _interopRequireDefault(require("react"));
var _popover = require("./popover.tokens");
var _Arrow = require("./Arrow");
var _jsxRuntime = require("react/jsx-runtime");
var StyledContent = (0, _styledComponents.default)(RadixPopover.Content).withConfig({
  displayName: "Content__StyledContent",
  componentId: "sc-1cnhdii-0"
})(["background:", ";border:", ";border-radius:", ";z-index:49;"], _popover.tokens.background.color, _popover.tokens.border.default, _popover.tokens.border.radius);
var Content = function Content(_ref) {
  var children = _ref.children,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'end' : _ref$align,
    _ref$showArrow = _ref.showArrow,
    showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(RadixPopover.Portal, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledContent, {
      sideOffset: offset,
      align: align,
      children: [children, showArrow ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Arrow.Arrow, {}) : null]
    })
  });
};
exports.Content = Content;